import React from 'react';

import { Consolidation } from '@futrli-sdk/consolidations';
import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';

import { PresentationCurrencyFilter } from './components/presentation-currency-filter';

interface ConsolidationsListFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  presentationCurrencyFilterValue: string;
  onPresentationCurrencyFilterChange: (value: string) => void;
  stickyTop?: number;
  consolidations?: Consolidation[];
}

export const ConsolidationsListFilterBar = ({
  searchTerm,
  onSearchChange,
  presentationCurrencyFilterValue,
  onPresentationCurrencyFilterChange,
  stickyTop,
  consolidations
}: ConsolidationsListFilterBarProps) => {
  return (
    <ListingPageFilterBar searchTerm={searchTerm} onSearchChange={onSearchChange} stickyTop={stickyTop}>
      <PresentationCurrencyFilter
        onChange={onPresentationCurrencyFilterChange}
        selectedValue={presentationCurrencyFilterValue}
        consolidations={consolidations}
      />
    </ListingPageFilterBar>
  );
};
